module.exports = __webpack_public_path__ + "img/user_profile_6.9fe6132d.png";